export default "__VITE_ASSET__C8DMTztF__"